<template>
  <div class="help padding_top">
    <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>
      ，即可进入【医生工作室】，在顶部菜单栏中点击<span class="orange">【banner管理】</span></p>
    <img src="../../../assets/doctorImg/editBanner_a.png" alt="" height="753">
    <p><strong>第二步：</strong>在【banner管理】页面中，可新增banner，并对之前上传的banner进行【编辑】【删除】等操作
    </p>
    <p>
      ① 【上传banner图片】：点击<span class="orange">【点击上传】</span>按钮，可将电脑本地图片上传至网站，作为网站主页的banner<br/>
      ② 【链接地址】：当输入的；链接地址有效时，他人可通过点击主页上的banner跳转至相应的链接网址<br/>
      ③ 【详细描述】：可简要对banner进行说明
    </p>
    <p class="orange">【注】最多支持上传5张banner</p>
    <img src="../../../assets/doctorImg/editBanner_b.png" alt="" height="489">
    <p>
      点击<span class="orange">【保存】</span>按钮，banner即上传成功<br/>
      点击<span class="orange">【重置】</span>按钮，则清空上传填写的数据
    </p>
  </div>

</template>

<script>
export default {
  name: "bannerEdit",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
